import styled from 'styled-components';

import { Flex } from '@/components/base';

const PageHeaderStyle = styled(Flex).attrs({
  j: 'space-between',
  a: 'center',
})`
  width: 100%;
  padding: 20px 32px;
  z-index: 10;
  background-color: ${(props) => props.theme.colors.gray100};
  overflow: hidden;
  flex-shrink: 0;
`;

export default PageHeaderStyle;
